import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import FontAwesomeIcon from 'react-fontawesome'

import './style.css'

class FooterView extends Component {
  render() {
    return (
      <div className="Footer">
        <Grid>
          <Row>
            <Col lg={6} xs={12}>
              <div className="left">
                <div className="title">Kapcsolat</div>
                <div>
                  <div className="data">
                    <FontAwesomeIcon name="map" /> 1126 Budapest Tartsay Vilmos
                    u.19.
                  </div>
                  <div className="data">
                    <FontAwesomeIcon name="facebook-square" />{' '}
                    <a href="https://www.facebook.com/budavet/">
                      Facebook oldalunk
                    </a>
                  </div>
                  <div className="data">
                    <FontAwesomeIcon name="phone" />{' '}
                    <a href="tel:+36-1-375-2624">+36-1-375-2624</a> -
                    időpontfoglalás
                  </div>
                  <div className="data">
                    <FontAwesomeIcon name="mobile" />{' '}
                    <a href="tel:+36-30-951-3040">
                      +36-30-951-3040 (Dr. Nagy Endre)
                    </a>
                  </div>
                  <div className="data">
                    <FontAwesomeIcon name="mobile" />{' '}
                    <a href="tel:+36-70-326-2300 ">
                      +36-70-326-2300 (Dr. Katona Ágnes)
                    </a>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={6} xs={12}>
              <div className="map">
                <iframe
                  title="Map"
                  width="100%"
                  height={300}
                  frameBorder={0}
                  style={{ border: 0 }}
                  src="https://www.google.com/maps/embed/v1/place?q=place_id:ChIJw_nBVyjcQUcRcpbko9MLtwg&key=AIzaSyBz_zD9-iGri7xwppEQGYjcg5RJ3Cwy1pk"
                  allowFullScreen
                />
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default FooterView



// WEBPACK FOOTER //
// ./src/components/Footer/FooterView.js